export const JSM_REQUEST_RESOLVER_ACTION_SUBJECT = 'jsmRequestResolverSideNavBanner';
